/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull bod-web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 252
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/implementation/bod-web)
 */
import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'production' | 'development'

export const ApiKey: Record<Environment, string> = {
  production: '7af0ada50139fe375f9e512f72e396f6',
  development: 'b7e1ebf7e22c690b60693b2f005f0f41',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '252',
    branch: 'main',
    source: 'bod-web',
    versionId: '06061b5b-8b5f-4ab9-8820-22fa61f7ee76',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
}

export interface LoadOptionsBase {
  disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment
  client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions }
}
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient }
}

export type LoadOptions =
  LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance

export interface IdentifyProperties {
  '[Experiment] ios-push-primer-v5'?: any
  /**
   * Serial number of a user's bike tablet (ex. format for v2 tablets: **BBMYX001132A** or v1 tablet: **IN00669A**)
   */
  'bike tablet serial number'?: string
  /**
   * What year was this customer born in, if set.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1900 |
   */
  birthyear?: number
  /**
   * Coach id of the user's coach. This is returned on the profile endpoint
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'coach id'?: number
  /**
   * model name of the user's device
   */
  'device model'?: string
  /**
   * model display name of the user's device
   */
  'device model display name'?: string
  /**
   * This field represents the user's individual entitlement purchases (LIFT4_PERM, ULTPORTIONFIX, etc)
   *
   *
   * Individual purchases contain "\_PERM" - Indicates the sale of a program that is own forever (ex LIIF4_PERM)
   *
   * Previous VIP early access will also be shown (ex LIIFT4), but unless they have a \_PERM they DO NOT indicate forever access.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'entitlement groups'?: string[]
  /**
   * What is the customer's gender, if set?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | male, female, other, not set |
   */
  gender?: 'male' | 'female' | 'other' | 'not set'
  /**
   * User unique identifier
   */
  guid: string
  /**
   * The customer has an active one day BODi pass
   */
  'has active odp'?: boolean
  /**
   * The customer currently has paired an Apple Watch to their iPhone. This helps us understand how many of our customers have Apple Watches available, and what percentage can use our Watch app.
   */
  'has apple watch'?: boolean
  /**
   * The customer has an active BODi entitlement.
   */
  'has bodi'?: boolean
  /**
   * When fetching the coach info of the user's coach, if the coach type is .corpCoach then set has corporate coach to true else set to false.
   */
  'has corporate coach'?: boolean
  /**
   * The customer has installed the Beachbody App on their Apple Watch.
   */
  'has watch app'?: boolean
  /**
   * The customer currently has paired Wear OS device to their Android phone. This helps us understand how many of our customers have Watches available, and what percentage can use our Watch app.
   */
  'has wear os device'?: boolean
  /**
   * IDFA advertising identifier
   */
  idfa?: string
  /**
   * a UUID that may be used to uniquely identify the device, same across apps from a single vendor
   */
  idfv?: string
  /**
   * User locale from the authn profile
   */
  locale?: string
  /**
   * User membership state from the authn profile
   */
  'membership state'?: string
  /**
   * User status of notification permission
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | not asked, denied, authorized |
   */
  'notification status'?: 'not asked' | 'denied' | 'authorized'
  /**
   * Used to help identify Shared Profiles, and their relationship with the primary account holder.
   */
  'primary account guid'?: string
  /**
   * User purchase region from the authn profile
   */
  'purchase region'?: string
  /**
   * List of users roles from authn profile
   *
   * | Rule | Value |
   * |---|---|
   * | Min Items | 1 |
   * | Unique Items | true |
   * | Item Type | string |
   *
   * @minItems 1
   */
  roles?: [string, ...string[]]
  /**
   * The date the user created an account as provided by /user/identity API
   */
  'start date'?: string
}

export interface AccountCreatedFailedProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * This property specifies the reason an event failed.
   */
  'failed reason'?: string
}

export interface AccountCreatedSuccessProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface AddToFavoritesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the content type of the item.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, workout, lesson, recipe |
   */
  'favorite content type': 'program' | 'block' | 'compilation' | 'workout' | 'lesson' | 'recipe'
  /**
   * Specifies the slug of a Favorite item.
   */
  'favorite item slug': string
  /**
   * Specifies the title of a Favorite item.
   */
  'favorite item title': string
  /**
   * Specifies the parent of a Favorite item, when applicable.
   */
  'favorite parent slug'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface ApplyFilterProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the filter (facet) the user is filtering by, such as "workoutTypes.items", "workoutLevels", "trainer.name"
   */
  filter: string
  /**
   * The specific value(s) selected within a filter, such as "Cardio", "Beginner", "Autumn Calabrese"
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'filter selection': string[]
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
}

export interface ClickBlockTileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Reports the collection from Sanity, for example a rail could be called `bdlav-week-2`
   */
  'collection slug'?: string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the title of the Rail (Collection).
   *
   * * To be sent in the localized language for a given user.
   */
  'rail title'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  'tile name': string
}

export interface ClickHealthEsteemTileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Specifies the localized name of the content entity (represented by the tile the user clicks on).
   */
  'tile name': string
  /**
   * Specifies the slug of the content entity (represented by the tile  the user clicks on).
   */
  'tile slug': string
}

export interface ClickResourceLinkProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The program from which the downloadable content was sourced.
   *
   * For example, a recipe from 2B Mindset downloaded from BODi Lava, will be credited with BODi Lava (3Au36TACh8j41B2g750Wsn)
   *
   *  Note that where a "Parent" isn't available, we use the "Primary Parent" value.
   */
  'parent id': string
  /**
   * The  program from which the downloadable content is created, regardless of where it was downloaded.
   *
   * For example, a recipe from 2B Mindset downloaded from BODi Lava, will be credited with 2B Mindset (Q6j5eG7tj3PSUghmZsFUwl )
   */
  'primary parent id': string
  /**
   * Specifies the Resource ID for an individual resource.
   */
  'resource id': string
  /**
   * Specifies the Resource Slug for an individual resource.
   */
  'resource slug': string
  /**
   * Specifies the Resource Title for an individual resource.
   *
   * * To be sent in the localized language for a given user.
   */
  'resource title': string
  /**
   * Specifies whether a resource is a URL or PDF.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | url, file |
   */
  'resource type': 'url' | 'file'
  /**
   * Specifies the URL of an individual resource. Applies to both URL and PDF resources.
   */
  'resource url': string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface CloseQuizProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The type of question
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | category, workoutDuration, level, gender, freeText |
   */
  'question type': 'category' | 'workoutDuration' | 'level' | 'gender' | 'freeText'
}

export interface CloseQuizResultsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface CreateSharedProfileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface DeleteSharedProfileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface DismissPostWorkoutScreenProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name'?: string
}

export interface EnrollInProgramProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
}

export interface EnrollInTrackProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * The content the user is enrolling in has multiple tracks
   */
  'has multiple tracks': boolean
  /**
   * The selected track is the default track for the content
   */
  'is default track': boolean
  'track name': string
}

export interface ExitVideoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'is completed': boolean
  /**
   * User's playback position in seconds when exiting the video
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'playback position': number
  /**
   * Determines if user is past the video completion threshold abd going to be shown Post Workout Experience
   */
  'show PWE': boolean
  /**
   * Duration of video in seconds
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'video duration': number
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * This is where you learn the parent of the content, for example "Liift-more", "April-2023-iron-block".
   *
   * If the video has no parent (BODi VODs), no value should be here. `none`
   */
  'video parent slug'?: string
  /**
   * Specifies the video slug.
   */
  'video slug': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title': string
}

export interface FreeAccountRegistrationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface JoinBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface LearnMoreProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The title of a link as shown to the user (in their language).
   */
  'link text'?: string
  /**
   * The URL associated with a link.
   */
  'link url'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface LoadMoreContentProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
}

export interface LogInProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * A code that  is returned when a process receives an error. It can be platform specific.
   */
  'error code'?: string
  /**
   * Any messages, errors, warnings, or otherwise, that are returned can help diagnose a potential issue.
   */
  message?: string
  source?: string
  success: boolean
}

export interface LogOutProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Whether the action was driven by the user
   */
  'is user driven'?: boolean
  /**
   * Any messages, errors, warnings, or otherwise, that are returned can help diagnose a potential issue.
   */
  message?: string
  source?: string
}

export interface NavigateToBodiCommerceProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Slug of the Program, Block, or Compilation which a piece of content belongs to.
   */
  'parent slug'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  source: string
}

export interface OpenChatProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Indicates if a chat conversation is new.
   */
  'is new conversation': boolean
}

export interface PlayVideoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Reports the collection from Sanity, for example a rail could be called `bdlav-week-2`
   */
  'collection slug'?: string
  /**
   * Describes the element being interacted with
   */
  element?: string
  /**
   * Device Free Storage %
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'free storage percent'?: number
  /**
   * Indicates whether the user is enrolled in the program
   */
  'is enrolled'?: boolean
  /**
   * True if the device is currently in low power mode.
   */
  'is low power mode'?: boolean
  /**
   * Reports `true` if another app (Spotify, Apple Music, etc) is currently playing audio on the device.
   */
  'is other audio playing'?: boolean
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Index of the suggested video within the rail. The Recently Watched endpoint suggests the next video within a Program / Block for a given user.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'suggested video index'?: number
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Index of the video within the rail.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'video index'?: number
  /**
   * This is where you learn the parent of the content, for example "Liift-more", "April-2023-iron-block".
   *
   * If the video has no parent (BODi VODs), no value should be here. `none`
   */
  'video parent slug'?: string
  /**
   * Specifies the video slug.
   */
  'video slug': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface PlayVideoAsAnonymousProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug'?: string
  'program slug'?: string
  /**
   * The values from this come from the "Playback endpoint", and are created by combining `firstName` and `lastName` with a space. In the case where there are multiple trainers, we comma separate these.
   */
  'trainer names': string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface PlayVideoFromBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the title of the Rail (Collection).
   *
   * * To be sent in the localized language for a given user.
   */
  'rail title'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
  /**
   * Specifies the type of video view that a user is engaged with:
   *
   * * **vod**: A BODi or BOD VOD.
   *
   * * **live participant**: A BODi Live Class, as a Participant.
   *
   * * **live bodcast**: A BODi Live Class, as a BODcast User.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | vod, live participant, live bodcast |
   */
  'view type': 'vod' | 'live participant' | 'live bodcast'
}

export interface PlayVideoFromCompilationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug': string
  /**
   * Specifies a Compilation's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'compilation title': string
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the title of the Rail (Collection).
   *
   * * To be sent in the localized language for a given user.
   */
  'rail title'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
  /**
   * Specifies the type of video view that a user is engaged with:
   *
   * * **vod**: A BODi or BOD VOD.
   *
   * * **live participant**: A BODi Live Class, as a Participant.
   *
   * * **live bodcast**: A BODi Live Class, as a BODcast User.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | vod, live participant, live bodcast |
   */
  'view type': 'vod' | 'live participant' | 'live bodcast'
}

export interface PlayVideoFromRecentlyWatchedProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * Index of the suggested video within the rail. The Recently Watched endpoint suggests the next video within a Program / Block for a given user.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'suggested video index': number
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Index of the video within the rail.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'video index': number
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface QualifiedViewAsAnonymousProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug'?: string
  'program slug'?: string
  /**
   * The values from this come from the "Playback endpoint", and are created by combining `firstName` and `lastName` with a space. In the case where there are multiple trainers, we comma separate these.
   */
  'trainer names': string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface RefreshAccessTokenProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, inactive, background, unknown |
   */
  'application state': 'active' | 'inactive' | 'background' | 'unknown'
  /**
   * A code that  is returned when a process receives an error. It can be platform specific.
   */
  'error code'?: string
  /**
   * Any messages, errors, warnings, or otherwise, that are returned can help diagnose a potential issue.
   */
  message?: string
  success: boolean
}

export interface RemoveFromFavoritesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the content type of the item.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, workout, lesson, recipe |
   */
  'favorite content type': 'program' | 'block' | 'compilation' | 'workout' | 'lesson' | 'recipe'
  /**
   * Specifies the slug of a Favorite item.
   */
  'favorite item slug': string
  /**
   * Specifies the title of a Favorite item.
   */
  'favorite item title': string
  /**
   * Specifies the parent of a Favorite item, when applicable.
   */
  'favorite parent slug'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface RestartProgramProgressProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
}

export interface RestartVideoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * What percentage is the customer towards the attached event.
   *
   * For badges, how close are they to earning this badge, or the next milestone?
   *
   * For videos, what percentage through the video is the user when triggering this event?
   *
   * The percent value should be a Int, values range between 0-100.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'percent progress'?: number
}

export interface ResumeVideoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * What percentage is the customer towards the attached event.
   *
   * For badges, how close are they to earning this badge, or the next milestone?
   *
   * For videos, what percentage through the video is the user when triggering this event?
   *
   * The percent value should be a Int, values range between 0-100.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'percent progress'?: number
}

export interface RetakeQuizProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface RetryLogInProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * A code that  is returned when a process receives an error. It can be platform specific.
   */
  'error code'?: string
  /**
   * Any messages, errors, warnings, or otherwise, that are returned can help diagnose a potential issue.
   */
  message?: string
  success: boolean
}

export interface Select10MinuteCtaProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface Select5ErCtaProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface SelectBadgeProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The name of the current badge if it's an Aggregate(Milestone), or just the general name is it's a Program or Museum Badge.
   */
  'badge name': string
  /**
   * Has the customer earned this badge yet? Aggregate(Milestone) will report "completed" after the first badge has been earned.
   *
   * available = no progress
   *
   * active = progress
   *
   * completed = earned
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, completed, available |
   */
  'badge status': 'active' | 'completed' | 'available'
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
}

export interface SelectBrowseAllProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
}

export interface SelectCommerceTileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the link item slug from Cocoa.
   */
  'link slug': string
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number': number
}

export interface SelectCompilationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'collection slug'?: string
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug': string
  /**
   * Specifies a Compilation's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'compilation title': string
  /**
   * Specifies whether a user is entitled to a given item.
   */
  'has entitlement': boolean
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface SelectCreateAccountProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface SelectCtaProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * The title of a link as shown to the user (in their language).
   */
  'link text'?: string
  /**
   * The URL associated with a link.
   */
  'link url'?: string
  /**
   * This is the slug used for a specific module. It will default to using the value from the CMS, where available.
   */
  'module slug'?: string
  /**
   * This is the (internal) title used for a specific module. It will default to using the value from the CMS, where available.
   *
   * Favor the "Internal Title" over customer-facing ones, to avoid localizations.
   */
  'module title'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface SelectFromFavoritesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the content type of the item.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, workout, lesson, recipe |
   */
  'favorite content type': 'program' | 'block' | 'compilation' | 'workout' | 'lesson' | 'recipe'
  /**
   * Specifies the slug of a Favorite item.
   */
  'favorite item slug': string
  /**
   * Specifies the title of a Favorite item.
   */
  'favorite item title': string
  /**
   * Specifies the parent of a Favorite item, when applicable.
   */
  'favorite parent slug'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface SelectLinkItemProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Reports the collection from Sanity, for example a rail could be called `bdlav-week-2`
   */
  'collection slug'?: string
  /**
   * Specifies the link item slug from Cocoa.
   */
  'link slug': string
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface SelectLockedVideoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Reports the collection from Sanity, for example a rail could be called `bdlav-week-2`
   */
  'collection slug'?: string
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug'?: string
  'program slug'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * This is where you learn the parent of the content, for example "Liift-more", "April-2023-iron-block".
   *
   * If the video has no parent (BODi VODs), no value should be here. `none`
   */
  'video parent slug'?: string
  /**
   * Specifies the video slug.
   */
  'video slug': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface SelectNavigationItemProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The name of selected item. Values come from Contentful, and can be used as a unique identifier (includes all translations).
   */
  'item title': string
}

export interface SelectProgramProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'collection slug'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * Specifies whether a user is entitled to a given item.
   */
  'has entitlement': boolean
  /**
   * Indicates whether the user is enrolled in the program
   */
  'is enrolled'?: boolean
  /**
   * The name of the Program
   */
  'program name'?: string
  'program slug'?: string
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
}

export interface SelectProgressSurfaceProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The name of the surface used in "My Progress" and possibly other modules. Current examples include: "limited edition badges", "recently earned badges", "in progress badges"
   */
  'surface name': string
}

export interface SelectQuicklinkProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  slug: string
}

export interface SelectQuizResultProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The index of the result.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'number of result': number
  'program slug'?: string
  /**
   * The score of the quiz result provided by Sanity.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 1 |
   */
  'score of result'?: number
}

export interface SelectRecentlyWatchedProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
}

export interface SelectSharedProfileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ShareBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
  /**
   * Specifies which platform the user choose to share on (to the level of specificity that is feasible to report).
   *
   * **For Web Desktop:**
   *
   * * Send the value which the user selected.
   *
   * **For Mobile Apps/Mobile Web:**
   *
   * * When a user selects *Share Block via*, send "native mobile share" as the value
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | copy link, facebook, twitter, bodgroups, native mobile share |
   */
  'share platform': 'copy link' | 'facebook' | 'twitter' | 'bodgroups' | 'native mobile share'
}

export interface ShareContentProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name'?: string
  /**
   * Specifies which platform the user choose to share on (to the level of specificity that is feasible to report).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | copy link, facebook, twitter, native mobile share, native web share |
   */
  'share platform'?:
    'copy link' | 'facebook' | 'twitter' | 'native mobile share' | 'native web share'
}

export interface ShowAlertProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * A generic title property.
   */
  'content title': string
  /**
   * Any messages, errors, warnings, or otherwise, that are returned can help diagnose a potential issue.
   */
  message?: string
}

export interface ShowDigitalContentAlertProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug': string
}

export interface SignUpToBodiProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Language preference describes the customer's selection in the unification header. When they click on a flag and change their preference, this value reflects that change. Examples include: en*\_US, es_US, en_GB, fr_FR, fr_CA, en_CA.*
   *
   * If you are looking for "locale" (country, and device language) check the "User Preferences".
   */
  'language preference': string
  /**
   * The title of a link as shown to the user (in their language).
   */
  'link text'?: string
  /**
   * The URL associated with a link.
   */
  'link url'?: string
  /**
   * Primarily for Web, used to identify which Module within the page layout, that the customer is triggering the event from.
   *
   * Expected values: header, footer, floater, fitness module, etc.
   */
  'screen module'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface StartConversationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Indicates the unique ID for a chat conversation.
   */
  'conversation id': string
}

export interface StartFeedFmMusicProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The unique feed.fm client id, used to help track whether the user has listened to a "First Play" for a given video.
   */
  'client id': string
  /**
   * The `pre-gain` value is a value set by FeedFM for the songs in a station. It could affect the volume amplification of the music.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'feed pre gain level': number
  /**
   * Is this the "First Play" for the video?
   */
  'is first play': boolean
  /**
   * What is the "Music" volume of the player when the Feed.fm music starts? This will help us understand how many of our users are listening to Feed.fm.
   *
   * The value is an integer between 0 and 100, rounding to the "Nearest neighbor".
   *
   * * 0 = off
   *
   * * 100 = full volume
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'music volume level': number
  /**
   * Which type of player is the user experiencing the feed.fm music in? `vod`, or Live (`participant`, `bodcast`).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | vod, participant, bodcast |
   */
  'player type': 'vod' | 'participant' | 'bodcast'
}

export interface SubmitActivationFailedProperties {
  /**
   * This enum property captures what version of the API was used
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | v1, v2 |
   */
  'api version': 'v1' | 'v2'
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * A code that  is returned when a process receives an error. It can be platform specific.
   */
  'error code'?: string
  /**
   * A meaningful explanation of why the event failed. This will help understand the particular error case. Must be provided.
   */
  'error message': string
}

export interface SubmitActivationSuccessProperties {
  /**
   * This enum property captures what version of the API was used
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | v1, v2 |
   */
  'api version': 'v1' | 'v2'
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface SwitchRecentlyWatchedTileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * Used to indicate the index of the Program/Block tile within the Jump Back In module.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'tile index': number
}

export interface SyncWebAppVersionProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'client version': string
  /**
   * Is video playback determines if the reload of web occured on starting video playback
   */
  'is video playback': boolean
  'server version': string
}

export interface TakeQuizProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface UnenrollFromProgramProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
}

export interface UnenrollInTrackProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * The content the user is enrolling in has multiple tracks
   */
  'has multiple tracks': boolean
  /**
   * The selected track is the default track for the content
   */
  'is default track': boolean
  'track name': string
}

export interface UnregisterBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface View5ErPromoProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewAccountProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewAllClassesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewAllFavoritesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewAllFitnessProgramsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewBadgeCelebrationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The slug of the respective badge(s).
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'badge slug'?: string[]
  /**
   * Array of badges with slug and earnedCount properties
   *
   *
   * \[{"slug": "123", "earnedCount": 1}\]
   */
  badges: any[]
}

export interface ViewBadgeDetailProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The name of the current badge if it's an Aggregate(Milestone), or just the general name is it's a Program or Museum Badge.
   */
  'badge name': string
  /**
   * Has the customer earned this badge yet? Aggregate(Milestone) will report "completed" after the first badge has been earned.
   *
   * available = no progress
   *
   * active = progress
   *
   * completed = earned
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, completed, available |
   */
  'badge status': 'active' | 'completed' | 'available'
  /**
   * What type of badge is this? aggregate(milestone), program, openfit(museum)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | aggregate, program, openfit, curated, container, uncategorized, segment, track |
   */
  'badge type':
    | 'aggregate'
    | 'program'
    | 'openfit'
    | 'curated'
    | 'container'
    | 'uncategorized'
    | 'segment'
    | 'track'
  /**
   * Number of times a user has earned this badge
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'earned count': number
  /**
   * What percentage is the customer towards the attached event.
   *
   * For badges, how close are they to earning this badge, or the next milestone?
   *
   * For videos, what percentage through the video is the user when triggering this event?
   *
   * The percent value should be a Int, values range between 0-100.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'percent progress'?: number
}

export interface ViewBadgeGridProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Section name for the badges being displayed
   */
  'badge section'?: string
  /**
   * Has the customer earned this badge yet? Aggregate(Milestone) will report "completed" after the first badge has been earned.
   *
   * available = no progress
   *
   * active = progress
   *
   * completed = earned
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, completed, available, limited, earn-again |
   */
  'badge status'?: 'active' | 'completed' | 'available' | 'limited' | 'earn-again'
}

export interface ViewBadgesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewBlockDetailProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * The ICID query parameter value from the URL
   */
  icid?: string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface ViewBodiInterstitialPageProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface ViewClassDetailWithinBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies the category(s), via slug values, that apply to a given class.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'class category': string[]
  /**
   * Specifies the duration of a BODi Class.
   *
   * * To be reported in seconds.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'class duration': number
  /**
   * Specifies the Class Instance ID.
   */
  'class instance id': string
  /**
   * Specifies the Scheduled Date/Time for a BODi Live Class.
   */
  'class scheduled datetime': string
  /**
   * Specifies a Class's Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'class title': string
  /**
   * Specifies the Trainer(s) Name, for a trainer associated with a given class.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'class trainer name': string[]
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
}

export interface ViewClassScheduleProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewClassesProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewCompilationDetailProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug': string
  /**
   * Specifies a Compilation's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'compilation title': string
  /**
   * The ICID query parameter value from the URL
   */
  icid?: string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface ViewCreateAccountScreenProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies whether the current content is being displayed within a modal viewport.
   *
   * `true` if it is a modal.
   */
  'is modal'?: boolean
}

export interface ViewDeviceActivationProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewErrorScreenProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * A code that  is returned when a process receives an error. It can be platform specific.
   */
  'error code'?: string
  /**
   * A meaningful explanation of why the event failed. This will help understand the particular error case. Must be provided.
   */
  'error message': string
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
}

export interface ViewFitnessQuizProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * `true` if the event is fired from a mobile web browser.
   */
  'is mobile': boolean
  /**
   * When a partner has shared a link to the quiz, the `referring rep id` captures the id of that Partner.
   */
  'referring rep id'?: string
}

export interface ViewForgotPasswordProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewFreeAccountRegistrationPageProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewGroupDetailProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The BODgroup's unique ID.
   */
  'group id': string
  /**
   * The name of the BODgroup being inspected?
   */
  'group name': string
  /**
   * The group role of the person opening the Group Detail page? Are they an `admin` of the group they are inspecting? Or just a `coach` (partner) or `participant`? Or, are they a `supertrainer`, or the `ceo`?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | coach, participant, admin, ceo, supertrainer |
   */
  'group role': 'coach' | 'participant' | 'admin' | 'ceo' | 'supertrainer'
  /**
   * What is the `state` of the Group. Is it `active` or  `past`? `draft`or `upcoming`.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | active, past, draft, upcoming |
   */
  'group state': 'active' | 'past' | 'draft' | 'upcoming'
}

export interface ViewGroupsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Which tab is the customer on? For example, in Groups (iOS and Android only), these tabs would be `all`, `active`, or `past`, and in Tracking they would be `daily activity` or `my progress.`
   *
   * For customers who are not part of any groups, and visit the groups tab, we use `no groups`
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | daily activity, my progress, all, active, past, no groups, open, invited |
   */
  'tracking tab name':
    'daily activity' | 'my progress' | 'all' | 'active' | 'past' | 'no groups' | 'open' | 'invited'
}

export interface ViewHomeProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The app theme set by the users in app settings
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | system, light, dark |
   */
  'app theme preference'?: 'system' | 'light' | 'dark'
  /**
   * The device locale for the user, i.e, they have set their iPhone's language to "French", even though they are in the US.
   */
  'device locale'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | light, dark |
   */
  'user preferred appearance'?: 'light' | 'dark'
}

export interface ViewLoginProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewMySettingsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewPostWorkoutScreenProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * What percentage is the customer towards the attached event.
   *
   * For badges, how close are they to earning this badge, or the next milestone?
   *
   * For videos, what percentage through the video is the user when triggering this event?
   *
   * The percent value should be a Int, values range between 0-100.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  'percent progress'?: number
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name'?: string
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * This is where you learn the parent of the content, for example "Liift-more", "April-2023-iron-block".
   *
   * If the video has no parent (BODi VODs), no value should be here. `none`
   */
  'video parent slug'?: string
  /**
   * Specifies the video slug.
   */
  'video slug'?: string
  /**
   * The number of workouts remaining until the user completes a program or reaches a similar milestone.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'workouts remaining'?: number
}

export interface ViewProfileProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * True if the customer is interacting with their profile, false if they are viewing the profile of another participant (in a BODgroup).
   */
  'is users profile': boolean
}

export interface ViewProgramDetailProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * The ICID query parameter value from the URL
   */
  icid?: string
  /**
   * Indicates whether the user is enrolled in the program
   */
  'is enrolled'?: boolean
  /**
   * The name of the Program
   */
  'program name'?: string
}

export interface ViewProgramResultsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewProgramsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewProgramsLandingProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewQuizQuestionProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The type of question
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | category, workoutDuration, level, gender, freeText |
   */
  'question type': 'category' | 'workoutDuration' | 'level' | 'gender' | 'freeText'
}

export interface ViewQuizResultsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewSearchProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewTrackingProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Captures the tab currently viewed by the user on screens with multiple tabs.
   *
   *
   * Values are recorded in English and lowercase.
   *
   *
   * Useful for analyzing user navigation behavior and tab engagement.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | programs, workouts, daily activity, my progress |
   */
  'tab name'?: 'programs' | 'workouts' | 'daily activity' | 'my progress'
  /**
   * Which tab is the customer on? For example, in Groups (iOS and Android only), these tabs would be `all`, `active`, or `past`, and in Tracking they would be `daily activity` or `my progress.`
   *
   * For customers who are not part of any groups, and visit the groups tab, we use `no groups`
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | daily activity, my progress, all, active, past, no groups, open, invited |
   */
  'tracking tab name':
    'daily activity' | 'my progress' | 'all' | 'active' | 'past' | 'no groups' | 'open' | 'invited'
}

export interface ViewValuePropModalProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewVideoDetailWithinBlockProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface ViewVideoDetailsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * This is where you learn the parent of the content, for example "Liift-more", "April-2023-iron-block".
   *
   * If the video has no parent (BODi VODs), no value should be here. `none`
   */
  'video parent slug'?: string
  /**
   * Specifies the video slug.
   */
  'video slug': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title': string
}

export interface ViewWelcomeProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
  /**
   * The device locale for the user, i.e, they have set their iPhone's language to "French", even though they are in the US.
   */
  'device locale'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | light, dark |
   */
  'user preferred appearance'?: 'light' | 'dark'
}

export interface ViewWorkoutResultsProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface ViewWorkoutsLandingProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface BlockDataProperties {
  /**
   * Specifies the Block ID of a given Block.
   */
  'block id': string
  /**
   * Specifies whether a user has **Joined** or **Not Joined** a given Block.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | joined, not joined |
   */
  'block join status': 'joined' | 'not joined'
  /**
   * Specifies the Block Slug of a given Block.
   */
  'block slug'?: string
  /**
   * Specifies the Start Date of a given Block.
   *
   * * To be sent to Amplitude in the same format as received from CoCoA.
   */
  'block start date': string
  /**
   * Specifies a Block's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'block title': string
  /**
   * Specifies whether a user is entitled (or not) to a given Block.
   */
  'has block entitlement': boolean
}

export interface ClassDataProperties {
  /**
   * Specifies the category(s), via slug values, that apply to a given class.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'class category': string[]
  /**
   * Specifies the duration of a BODi Class.
   *
   * * To be reported in seconds.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'class duration': number
  /**
   * Specifies the Class Instance ID.
   */
  'class instance id': string
  /**
   * Specifies the Scheduled Date/Time for a BODi Live Class.
   */
  'class scheduled datetime': string
  /**
   * Specifies a Class's Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'class title': string
  /**
   * Specifies the Trainer(s) Name, for a trainer associated with a given class.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'class trainer name': string[]
}

export interface CompilationDataProperties {
  /**
   * Specifies the slug of a given Compilation.
   */
  'compilation slug': string
  /**
   * Specifies a Compilation's External Title.
   *
   * * To be sent in the localized language for a given user.
   */
  'compilation title': string
}

export interface ContentDataProperties {
  'content slug'?: string
  /**
   * A generic title property.
   */
  'content title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, collection, workout, recipe, episode, lesson, promo |
   */
  'content type'?:
    | 'program'
    | 'block'
    | 'compilation'
    | 'collection'
    | 'workout'
    | 'recipe'
    | 'episode'
    | 'lesson'
    | 'promo'
}

export interface FavoritesDataProperties {
  /**
   * Specifies the content type of the item.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | program, block, compilation, workout, lesson, recipe |
   */
  'favorite content type': 'program' | 'block' | 'compilation' | 'workout' | 'lesson' | 'recipe'
  /**
   * Specifies the slug of a Favorite item.
   */
  'favorite item slug': string
  /**
   * Specifies the title of a Favorite item.
   */
  'favorite item title': string
  /**
   * Specifies the parent of a Favorite item, when applicable.
   */
  'favorite parent slug'?: string
}

export interface GlobalProperties {
  /**
   * Name of app that is firing the event and the value is derived from the source name. This marked as optional but is actually required field on all events. This will be sent automatically on all events through our Amplitude Analytics tracker code. The reason it is not required is so that the code is easier to maintain and new events do not have to add this property specifically.
   */
  'app name'?: string
}

export interface LinkDataProperties {
  /**
   * The title of a link as shown to the user (in their language).
   */
  'link text'?: string
  /**
   * The URL associated with a link.
   */
  'link url'?: string
}

export interface ModuleDataProperties {
  /**
   * This is the slug used for a specific module. It will default to using the value from the CMS, where available.
   */
  'module slug'?: string
  /**
   * This is the (internal) title used for a specific module. It will default to using the value from the CMS, where available.
   *
   * Favor the "Internal Title" over customer-facing ones, to avoid localizations.
   */
  'module title'?: string
}

export interface ProgramDataProperties {
  /**
   * The name of the Program
   */
  'program name'?: string
  'program slug'?: string
}

export interface RailItemProperties {
  /**
   * Specifies the position of the item within the given rail (collection).
   *
   * * Count starts at 1 (left to right/top to bottom).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  'rail item number'?: number
  /**
   * Specifies the title of the Rail (Collection).
   *
   * * To be sent in the localized language for a given user.
   */
  'rail title'?: string
}

export interface ResourceDataProperties {
  /**
   * The program from which the downloadable content was sourced.
   *
   * For example, a recipe from 2B Mindset downloaded from BODi Lava, will be credited with BODi Lava (3Au36TACh8j41B2g750Wsn)
   *
   *  Note that where a "Parent" isn't available, we use the "Primary Parent" value.
   */
  'parent id': string
  /**
   * The  program from which the downloadable content is created, regardless of where it was downloaded.
   *
   * For example, a recipe from 2B Mindset downloaded from BODi Lava, will be credited with 2B Mindset (Q6j5eG7tj3PSUghmZsFUwl )
   */
  'primary parent id': string
  /**
   * Specifies the Resource ID for an individual resource.
   */
  'resource id': string
  /**
   * Specifies the Resource Slug for an individual resource.
   */
  'resource slug': string
  /**
   * Specifies the Resource Title for an individual resource.
   *
   * * To be sent in the localized language for a given user.
   */
  'resource title': string
  /**
   * Specifies whether a resource is a URL or PDF.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | url, file |
   */
  'resource type': 'url' | 'file'
  /**
   * Specifies the URL of an individual resource. Applies to both URL and PDF resources.
   */
  'resource url': string
}

export interface ScreenProperties {
  /**
   * Specifies the name of the screen that the user is in.
   *
   * * All PDPs are moving to use `content detail`
   *
   *   * we will retire `compilation detail`, `block detail`, `program detail`
   *
   * * Content Detail Modals (the additional information you see when tapping on content in a PDP) are `content details modal`
   *
   * * Other examples: `home`, `badge detail`, `bodi`, `search`, `all favorites`, `downloads`
   */
  'screen name': string
  /**
   * Specifies the type of screen that the user is in.
   *
   * * Such as Home, Search, or Block Detail.
   *
   * * Individual Events will specify the values that should be sent for this property.
   */
  'screen type'?: string
}

export interface VideoDataProperties {
  /**
   * Specifies whether a video is **BOD** or **BODi**.
   *
   * * The CoCoA response will have a catalog field to specify whether a video is bod *or* bodi.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | bod, bodi |
   */
  catalog?: 'bod' | 'bodi'
  /**
   * Specifies the Video ID.
   */
  'video id': string
  /**
   * Specifies the localized title of the video entity (Workout Title, Recipe Title, etc.)
   */
  'video title'?: string
}

export interface ViewerDataProperties {
  /**
   * Specifies the type of video view that a user is engaged with:
   *
   * * **vod**: A BODi or BOD VOD.
   *
   * * **live participant**: A BODi Live Class, as a Participant.
   *
   * * **live bodcast**: A BODi Live Class, as a BODcast User.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | vod, live participant, live bodcast |
   */
  'view type': 'vod' | 'live participant' | 'live bodcast'
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY

  constructor(public event_properties: IdentifyProperties) {
    this.event_properties = event_properties
  }
}

export class AccountCreatedFailed implements BaseEvent {
  event_type = 'account created failed'

  constructor(public event_properties?: AccountCreatedFailedProperties) {
    this.event_properties = event_properties
  }
}

export class AccountCreatedSuccess implements BaseEvent {
  event_type = 'account created success'

  constructor(public event_properties?: AccountCreatedSuccessProperties) {
    this.event_properties = event_properties
  }
}

export class AddToFavorites implements BaseEvent {
  event_type = 'add to favorites'

  constructor(public event_properties: AddToFavoritesProperties) {
    this.event_properties = event_properties
  }
}

export class ApplyFilter implements BaseEvent {
  event_type = 'apply filter'

  constructor(public event_properties: ApplyFilterProperties) {
    this.event_properties = event_properties
  }
}

export class ClickBlockTile implements BaseEvent {
  event_type = 'click block tile'

  constructor(public event_properties: ClickBlockTileProperties) {
    this.event_properties = event_properties
  }
}

export class ClickHealthEsteemTile implements BaseEvent {
  event_type = 'click health esteem tile'

  constructor(public event_properties: ClickHealthEsteemTileProperties) {
    this.event_properties = event_properties
  }
}

export class ClickResourceLink implements BaseEvent {
  event_type = 'click resource link'

  constructor(public event_properties: ClickResourceLinkProperties) {
    this.event_properties = event_properties
  }
}

export class CloseQuiz implements BaseEvent {
  event_type = 'close quiz'

  constructor(public event_properties: CloseQuizProperties) {
    this.event_properties = event_properties
  }
}

export class CloseQuizResults implements BaseEvent {
  event_type = 'close quiz results'

  constructor(public event_properties?: CloseQuizResultsProperties) {
    this.event_properties = event_properties
  }
}

export class CreateSharedProfile implements BaseEvent {
  event_type = 'create shared profile'

  constructor(public event_properties?: CreateSharedProfileProperties) {
    this.event_properties = event_properties
  }
}

export class DeleteSharedProfile implements BaseEvent {
  event_type = 'delete shared profile'

  constructor(public event_properties?: DeleteSharedProfileProperties) {
    this.event_properties = event_properties
  }
}

export class DismissPostWorkoutScreen implements BaseEvent {
  event_type = 'dismiss post workout screen'

  constructor(public event_properties?: DismissPostWorkoutScreenProperties) {
    this.event_properties = event_properties
  }
}

export class EnrollInProgram implements BaseEvent {
  event_type = 'enroll in program'

  constructor(public event_properties?: EnrollInProgramProperties) {
    this.event_properties = event_properties
  }
}

export class EnrollInTrack implements BaseEvent {
  event_type = 'enroll in track'

  constructor(public event_properties: EnrollInTrackProperties) {
    this.event_properties = event_properties
  }
}

export class ExitVideo implements BaseEvent {
  event_type = 'exit video'

  constructor(public event_properties: ExitVideoProperties) {
    this.event_properties = event_properties
  }
}

export class FreeAccountRegistration implements BaseEvent {
  event_type = 'free account registration'

  constructor(public event_properties?: FreeAccountRegistrationProperties) {
    this.event_properties = event_properties
  }
}

export class JoinBlock implements BaseEvent {
  event_type = 'join block'

  constructor(public event_properties: JoinBlockProperties) {
    this.event_properties = event_properties
  }
}

export class LearnMore implements BaseEvent {
  event_type = 'learn more'

  constructor(public event_properties: LearnMoreProperties) {
    this.event_properties = event_properties
  }
}

export class LoadMoreContent implements BaseEvent {
  event_type = 'load more content'

  constructor(public event_properties: LoadMoreContentProperties) {
    this.event_properties = event_properties
  }
}

export class LogIn implements BaseEvent {
  event_type = 'log in'

  constructor(public event_properties: LogInProperties) {
    this.event_properties = event_properties
  }
}

export class LogOut implements BaseEvent {
  event_type = 'log out'

  constructor(public event_properties?: LogOutProperties) {
    this.event_properties = event_properties
  }
}

export class NavigateToBodiCommerce implements BaseEvent {
  event_type = 'navigate to bodi commerce'

  constructor(public event_properties: NavigateToBodiCommerceProperties) {
    this.event_properties = event_properties
  }
}

export class OpenChat implements BaseEvent {
  event_type = 'open chat'

  constructor(public event_properties: OpenChatProperties) {
    this.event_properties = event_properties
  }
}

export class PlayVideo implements BaseEvent {
  event_type = 'play video'

  constructor(public event_properties: PlayVideoProperties) {
    this.event_properties = event_properties
  }
}

export class PlayVideoAsAnonymous implements BaseEvent {
  event_type = 'play video as anonymous'

  constructor(public event_properties: PlayVideoAsAnonymousProperties) {
    this.event_properties = event_properties
  }
}

export class PlayVideoFromBlock implements BaseEvent {
  event_type = 'play video from block'

  constructor(public event_properties: PlayVideoFromBlockProperties) {
    this.event_properties = event_properties
  }
}

export class PlayVideoFromCompilation implements BaseEvent {
  event_type = 'play video from compilation'

  constructor(public event_properties: PlayVideoFromCompilationProperties) {
    this.event_properties = event_properties
  }
}

export class PlayVideoFromRecentlyWatched implements BaseEvent {
  event_type = 'play video from recently watched'

  constructor(public event_properties: PlayVideoFromRecentlyWatchedProperties) {
    this.event_properties = event_properties
  }
}

export class QualifiedViewAsAnonymous implements BaseEvent {
  event_type = 'qualified view as anonymous'

  constructor(public event_properties: QualifiedViewAsAnonymousProperties) {
    this.event_properties = event_properties
  }
}

export class RefreshAccessToken implements BaseEvent {
  event_type = 'refresh access token'

  constructor(public event_properties: RefreshAccessTokenProperties) {
    this.event_properties = event_properties
  }
}

export class RemoveFromFavorites implements BaseEvent {
  event_type = 'remove from favorites'

  constructor(public event_properties: RemoveFromFavoritesProperties) {
    this.event_properties = event_properties
  }
}

export class RestartProgramProgress implements BaseEvent {
  event_type = 'restart program progress'

  constructor(public event_properties?: RestartProgramProgressProperties) {
    this.event_properties = event_properties
  }
}

export class RestartVideo implements BaseEvent {
  event_type = 'restart video'

  constructor(public event_properties?: RestartVideoProperties) {
    this.event_properties = event_properties
  }
}

export class ResumeVideo implements BaseEvent {
  event_type = 'resume video'

  constructor(public event_properties?: ResumeVideoProperties) {
    this.event_properties = event_properties
  }
}

export class RetakeQuiz implements BaseEvent {
  event_type = 'retake quiz'

  constructor(public event_properties?: RetakeQuizProperties) {
    this.event_properties = event_properties
  }
}

export class RetryLogIn implements BaseEvent {
  event_type = 'retry log in'

  constructor(public event_properties: RetryLogInProperties) {
    this.event_properties = event_properties
  }
}

export class Select10MinuteCta implements BaseEvent {
  event_type = 'select 10 minute cta'

  constructor(public event_properties?: Select10MinuteCtaProperties) {
    this.event_properties = event_properties
  }
}

export class Select5ErCta implements BaseEvent {
  event_type = 'select 5er cta'

  constructor(public event_properties?: Select5ErCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectBadge implements BaseEvent {
  event_type = 'select badge'

  constructor(public event_properties: SelectBadgeProperties) {
    this.event_properties = event_properties
  }
}

export class SelectBrowseAll implements BaseEvent {
  event_type = 'select browse all'

  constructor(public event_properties: SelectBrowseAllProperties) {
    this.event_properties = event_properties
  }
}

export class SelectCommerceTile implements BaseEvent {
  event_type = 'select commerce tile'

  constructor(public event_properties: SelectCommerceTileProperties) {
    this.event_properties = event_properties
  }
}

export class SelectCompilation implements BaseEvent {
  event_type = 'select compilation'

  constructor(public event_properties: SelectCompilationProperties) {
    this.event_properties = event_properties
  }
}

export class SelectCreateAccount implements BaseEvent {
  event_type = 'select create account'

  constructor(public event_properties?: SelectCreateAccountProperties) {
    this.event_properties = event_properties
  }
}

export class SelectCta implements BaseEvent {
  event_type = 'select cta'

  constructor(public event_properties: SelectCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectFromFavorites implements BaseEvent {
  event_type = 'select from favorites'

  constructor(public event_properties: SelectFromFavoritesProperties) {
    this.event_properties = event_properties
  }
}

export class SelectLinkItem implements BaseEvent {
  event_type = 'select link item'

  constructor(public event_properties: SelectLinkItemProperties) {
    this.event_properties = event_properties
  }
}

export class SelectLockedVideo implements BaseEvent {
  event_type = 'select locked video'

  constructor(public event_properties: SelectLockedVideoProperties) {
    this.event_properties = event_properties
  }
}

export class SelectNavigationItem implements BaseEvent {
  event_type = 'select navigation item'

  constructor(public event_properties: SelectNavigationItemProperties) {
    this.event_properties = event_properties
  }
}

export class SelectProgram implements BaseEvent {
  event_type = 'select program'

  constructor(public event_properties: SelectProgramProperties) {
    this.event_properties = event_properties
  }
}

export class SelectProgressSurface implements BaseEvent {
  event_type = 'select progress surface'

  constructor(public event_properties: SelectProgressSurfaceProperties) {
    this.event_properties = event_properties
  }
}

export class SelectQuicklink implements BaseEvent {
  event_type = 'select quicklink'

  constructor(public event_properties: SelectQuicklinkProperties) {
    this.event_properties = event_properties
  }
}

export class SelectQuizResult implements BaseEvent {
  event_type = 'select quiz result'

  constructor(public event_properties: SelectQuizResultProperties) {
    this.event_properties = event_properties
  }
}

export class SelectRecentlyWatched implements BaseEvent {
  event_type = 'select recently watched'

  constructor(public event_properties?: SelectRecentlyWatchedProperties) {
    this.event_properties = event_properties
  }
}

export class SelectSharedProfile implements BaseEvent {
  event_type = 'select shared profile'

  constructor(public event_properties?: SelectSharedProfileProperties) {
    this.event_properties = event_properties
  }
}

export class ShareBlock implements BaseEvent {
  event_type = 'share block'

  constructor(public event_properties: ShareBlockProperties) {
    this.event_properties = event_properties
  }
}

export class ShareContent implements BaseEvent {
  event_type = 'share content'

  constructor(public event_properties?: ShareContentProperties) {
    this.event_properties = event_properties
  }
}

export class ShowAlert implements BaseEvent {
  event_type = 'show alert'

  constructor(public event_properties: ShowAlertProperties) {
    this.event_properties = event_properties
  }
}

export class ShowDigitalContentAlert implements BaseEvent {
  event_type = 'show digital content alert'

  constructor(public event_properties: ShowDigitalContentAlertProperties) {
    this.event_properties = event_properties
  }
}

export class SignUpToBodi implements BaseEvent {
  event_type = 'sign up to bodi'

  constructor(public event_properties: SignUpToBodiProperties) {
    this.event_properties = event_properties
  }
}

export class StartConversation implements BaseEvent {
  event_type = 'start conversation'

  constructor(public event_properties: StartConversationProperties) {
    this.event_properties = event_properties
  }
}

export class StartFeedFmMusic implements BaseEvent {
  event_type = 'start feed fm music'

  constructor(public event_properties: StartFeedFmMusicProperties) {
    this.event_properties = event_properties
  }
}

export class SubmitActivationFailed implements BaseEvent {
  event_type = 'submit activation failed'

  constructor(public event_properties: SubmitActivationFailedProperties) {
    this.event_properties = event_properties
  }
}

export class SubmitActivationSuccess implements BaseEvent {
  event_type = 'submit activation success'

  constructor(public event_properties: SubmitActivationSuccessProperties) {
    this.event_properties = event_properties
  }
}

export class SwitchRecentlyWatchedTile implements BaseEvent {
  event_type = 'switch recently watched tile'

  constructor(public event_properties: SwitchRecentlyWatchedTileProperties) {
    this.event_properties = event_properties
  }
}

export class SyncWebAppVersion implements BaseEvent {
  event_type = 'sync web app version'

  constructor(public event_properties: SyncWebAppVersionProperties) {
    this.event_properties = event_properties
  }
}

export class TakeQuiz implements BaseEvent {
  event_type = 'take quiz'

  constructor(public event_properties?: TakeQuizProperties) {
    this.event_properties = event_properties
  }
}

export class UnenrollFromProgram implements BaseEvent {
  event_type = 'unenroll from program'

  constructor(public event_properties?: UnenrollFromProgramProperties) {
    this.event_properties = event_properties
  }
}

export class UnenrollInTrack implements BaseEvent {
  event_type = 'unenroll in track'

  constructor(public event_properties: UnenrollInTrackProperties) {
    this.event_properties = event_properties
  }
}

export class UnregisterBlock implements BaseEvent {
  event_type = 'unregister block'

  constructor(public event_properties: UnregisterBlockProperties) {
    this.event_properties = event_properties
  }
}

export class View5ErPromo implements BaseEvent {
  event_type = 'view 5er promo'

  constructor(public event_properties?: View5ErPromoProperties) {
    this.event_properties = event_properties
  }
}

export class ViewAccount implements BaseEvent {
  event_type = 'view account'

  constructor(public event_properties?: ViewAccountProperties) {
    this.event_properties = event_properties
  }
}

export class ViewAllClasses implements BaseEvent {
  event_type = 'view all classes'

  constructor(public event_properties?: ViewAllClassesProperties) {
    this.event_properties = event_properties
  }
}

export class ViewAllFavorites implements BaseEvent {
  event_type = 'view all favorites'

  constructor(public event_properties?: ViewAllFavoritesProperties) {
    this.event_properties = event_properties
  }
}

export class ViewAllFitnessPrograms implements BaseEvent {
  event_type = 'view all fitness programs'

  constructor(public event_properties?: ViewAllFitnessProgramsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBadgeCelebration implements BaseEvent {
  event_type = 'view badge celebration'

  constructor(public event_properties: ViewBadgeCelebrationProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBadgeDetail implements BaseEvent {
  event_type = 'view badge detail'

  constructor(public event_properties: ViewBadgeDetailProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBadgeGrid implements BaseEvent {
  event_type = 'view badge grid'

  constructor(public event_properties?: ViewBadgeGridProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBadges implements BaseEvent {
  event_type = 'view badges'

  constructor(public event_properties?: ViewBadgesProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBlockDetail implements BaseEvent {
  event_type = 'view block detail'

  constructor(public event_properties: ViewBlockDetailProperties) {
    this.event_properties = event_properties
  }
}

export class ViewBodiInterstitialPage implements BaseEvent {
  event_type = 'view bodi interstitial page'

  constructor(public event_properties: ViewBodiInterstitialPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewClassDetailWithinBlock implements BaseEvent {
  event_type = 'view class detail within block'

  constructor(public event_properties: ViewClassDetailWithinBlockProperties) {
    this.event_properties = event_properties
  }
}

export class ViewClassSchedule implements BaseEvent {
  event_type = 'view class schedule'

  constructor(public event_properties?: ViewClassScheduleProperties) {
    this.event_properties = event_properties
  }
}

export class ViewClasses implements BaseEvent {
  event_type = 'view classes'

  constructor(public event_properties?: ViewClassesProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCompilationDetail implements BaseEvent {
  event_type = 'view compilation detail'

  constructor(public event_properties: ViewCompilationDetailProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCreateAccountScreen implements BaseEvent {
  event_type = 'view create account screen'

  constructor(public event_properties?: ViewCreateAccountScreenProperties) {
    this.event_properties = event_properties
  }
}

export class ViewDeviceActivation implements BaseEvent {
  event_type = 'view device activation'

  constructor(public event_properties?: ViewDeviceActivationProperties) {
    this.event_properties = event_properties
  }
}

export class ViewErrorScreen implements BaseEvent {
  event_type = 'view error screen'

  constructor(public event_properties: ViewErrorScreenProperties) {
    this.event_properties = event_properties
  }
}

export class ViewFitnessQuiz implements BaseEvent {
  event_type = 'view fitness quiz'

  constructor(public event_properties: ViewFitnessQuizProperties) {
    this.event_properties = event_properties
  }
}

export class ViewForgotPassword implements BaseEvent {
  event_type = 'view forgot password'

  constructor(public event_properties?: ViewForgotPasswordProperties) {
    this.event_properties = event_properties
  }
}

export class ViewFreeAccountRegistrationPage implements BaseEvent {
  event_type = 'view free account registration page'

  constructor(public event_properties?: ViewFreeAccountRegistrationPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewGroupDetail implements BaseEvent {
  event_type = 'view group detail'

  constructor(public event_properties: ViewGroupDetailProperties) {
    this.event_properties = event_properties
  }
}

export class ViewGroups implements BaseEvent {
  event_type = 'view groups'

  constructor(public event_properties: ViewGroupsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewHome implements BaseEvent {
  event_type = 'view home'

  constructor(public event_properties?: ViewHomeProperties) {
    this.event_properties = event_properties
  }
}

export class ViewLogin implements BaseEvent {
  event_type = 'view login'

  constructor(public event_properties?: ViewLoginProperties) {
    this.event_properties = event_properties
  }
}

export class ViewMySettings implements BaseEvent {
  event_type = 'view my settings'

  constructor(public event_properties?: ViewMySettingsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewPostWorkoutScreen implements BaseEvent {
  event_type = 'view post workout screen'

  constructor(public event_properties: ViewPostWorkoutScreenProperties) {
    this.event_properties = event_properties
  }
}

export class ViewProfile implements BaseEvent {
  event_type = 'view profile'

  constructor(public event_properties: ViewProfileProperties) {
    this.event_properties = event_properties
  }
}

export class ViewProgramDetail implements BaseEvent {
  event_type = 'view program detail'

  constructor(public event_properties?: ViewProgramDetailProperties) {
    this.event_properties = event_properties
  }
}

export class ViewProgramResults implements BaseEvent {
  event_type = 'view program results'

  constructor(public event_properties?: ViewProgramResultsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewPrograms implements BaseEvent {
  event_type = 'view programs'

  constructor(public event_properties?: ViewProgramsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewProgramsLanding implements BaseEvent {
  event_type = 'view programs landing'

  constructor(public event_properties?: ViewProgramsLandingProperties) {
    this.event_properties = event_properties
  }
}

export class ViewQuizQuestion implements BaseEvent {
  event_type = 'view quiz question'

  constructor(public event_properties: ViewQuizQuestionProperties) {
    this.event_properties = event_properties
  }
}

export class ViewQuizResults implements BaseEvent {
  event_type = 'view quiz results'

  constructor(public event_properties?: ViewQuizResultsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewSearch implements BaseEvent {
  event_type = 'view search'

  constructor(public event_properties?: ViewSearchProperties) {
    this.event_properties = event_properties
  }
}

export class ViewTracking implements BaseEvent {
  event_type = 'view tracking'

  constructor(public event_properties: ViewTrackingProperties) {
    this.event_properties = event_properties
  }
}

export class ViewValuePropModal implements BaseEvent {
  event_type = 'view value prop modal'

  constructor(public event_properties?: ViewValuePropModalProperties) {
    this.event_properties = event_properties
  }
}

export class ViewVideoDetailWithinBlock implements BaseEvent {
  event_type = 'view video detail within block'

  constructor(public event_properties: ViewVideoDetailWithinBlockProperties) {
    this.event_properties = event_properties
  }
}

export class ViewVideoDetails implements BaseEvent {
  event_type = 'view video details'

  constructor(public event_properties: ViewVideoDetailsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewWelcome implements BaseEvent {
  event_type = 'view welcome'

  constructor(public event_properties?: ViewWelcomeProperties) {
    this.event_properties = event_properties
  }
}

export class ViewWorkoutResults implements BaseEvent {
  event_type = 'view workout results'

  constructor(public event_properties?: ViewWorkoutResultsProperties) {
    this.event_properties = event_properties
  }
}

export class ViewWorkoutsLanding implements BaseEvent {
  event_type = 'view workouts landing'

  constructor(public event_properties?: ViewWorkoutsLandingProperties) {
    this.event_properties = event_properties
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * account created failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/account%20created%20failed)
   *
   * This event signifies the failure of creating a new user account.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  accountCreatedFailed(
    properties?: AccountCreatedFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountCreatedFailed(properties), options);
  }

  /**
   * account created success
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/account%20created%20success)
   *
   * This event signifies the successful creation of a new user account.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  accountCreatedSuccess(
    properties?: AccountCreatedSuccessProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountCreatedSuccess(properties), options);
  }

  /**
   * add to favorites
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/add%20to%20favorites)
   *
   * Tracks when a user adds an item to their Favorites.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  addToFavorites(
    properties: AddToFavoritesProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToFavorites(properties), options);
  }

  /**
   * apply filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/apply%20filter)
   *
   * Triggered when a user applies a filter to refine content sets or search results.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  applyFilter(
    properties: ApplyFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplyFilter(properties), options);
  }

  /**
   * click block tile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/click%20block%20tile)
   *
   * Fired when the user clicks on a Block Tile to display a Block Detail View
   *
   * **Notes:**
   *
   * * **tile name** is Block's External Title in Localized Language
   *
   * * **rail title** is the Block Collection Title in Localized Language
   *
   * * **screen name** values: "home", "bodi landing", "compilation detail" or "block detail"
   *
   * * **screen type** values: "home", "bodi landing", "compilation", or "block"
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  clickBlockTile(
    properties: ClickBlockTileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickBlockTile(properties), options);
  }

  /**
   * click health esteem tile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/click%20health%20esteem%20tile)
   *
   * Fired when the user clicks on a tile in the Health Esteem Module (Such as Fitness, Nutrition, or Mindset)
   *
   * **Notes:**
   *
   * * **screen name** is "home"
   *
   * * **screen type** is "home"
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  clickHealthEsteemTile(
    properties: ClickHealthEsteemTileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickHealthEsteemTile(properties), options);
  }

  /**
   * click resource link
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/click%20resource%20link)
   *
   * Fired when the user clicks on a Resource Link within a Resource Collection Module on a Block or Compilation Detail View
   *
   * * **screen name** will be "block detail" or “compilation detail"
   *
   * * **screen type** will be "block" or “compilation”
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  clickResourceLink(
    properties: ClickResourceLinkProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickResourceLink(properties), options);
  }

  /**
   * close quiz
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/close%20quiz)
   *
   * Tracks when a user exits the quiz.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  closeQuiz(
    properties: CloseQuizProperties,
    options?: EventOptions,
  ) {
    return this.track(new CloseQuiz(properties), options);
  }

  /**
   * close quiz results
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/close%20quiz%20results)
   *
   * Tracks when a user exits the quiz results screen.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  closeQuizResults(
    properties?: CloseQuizResultsProperties,
    options?: EventOptions,
  ) {
    return this.track(new CloseQuizResults(properties), options);
  }

  /**
   * create shared profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/create%20shared%20profile)
   *
   * Tracks when a user creates a profile intended for sharing their subscription content with others in the household
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  createSharedProfile(
    properties?: CreateSharedProfileProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateSharedProfile(properties), options);
  }

  /**
   * delete shared profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/delete%20shared%20profile)
   *
   * Records when a user removes a profile on the account indicating the end of access to that profile's content and data.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  deleteSharedProfile(
    properties?: DeleteSharedProfileProperties,
    options?: EventOptions,
  ) {
    return this.track(new DeleteSharedProfile(properties), options);
  }

  /**
   * dismiss post workout screen
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/dismiss%20post%20workout%20screen)
   *
   * Triggered when the user dismisses or closes the Post-Workout Screen (or modal).
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  dismissPostWorkoutScreen(
    properties?: DismissPostWorkoutScreenProperties,
    options?: EventOptions,
  ) {
    return this.track(new DismissPostWorkoutScreen(properties), options);
  }

  /**
   * enroll in program
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/enroll%20in%20program)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  enrollInProgram(
    properties?: EnrollInProgramProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnrollInProgram(properties), options);
  }

  /**
   * enroll in track
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/enroll%20in%20track)
   *
   * User enrolls in a track for the content
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  enrollInTrack(
    properties: EnrollInTrackProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnrollInTrack(properties), options);
  }

  /**
   * exit video
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/exit%20video)
   *
   * This event is triggered when a user stops or closes a video within the application. It captures the action of exiting video playback, indicating the end of the user's viewing session for that particular video.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  exitVideo(
    properties: ExitVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExitVideo(properties), options);
  }

  /**
   * free account registration
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/free%20account%20registration)
   *
   * Fired when a user completes the Free Account Registration on Web.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  freeAccountRegistration(
    properties?: FreeAccountRegistrationProperties,
    options?: EventOptions,
  ) {
    return this.track(new FreeAccountRegistration(properties), options);
  }

  /**
   * join block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/join%20block)
   *
   * Fired when the user clicks on the **Join Now** button on a Block Detail View (which reflects the user's intention to join the Block).
   *
   * **Notes:**
   *
   * * **screen name** is "block detail"
   *
   * * **screen type** is "block"
   *
   * * **block join status** should be "joined" to reflect the user's intention to be register for the Block.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  joinBlock(
    properties: JoinBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new JoinBlock(properties), options);
  }

  /**
   * learn more
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/learn%20more)
   *
   * Fired when a user clicks or taps on a link to learn more/see more details about an offering.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  learnMore(
    properties: LearnMoreProperties,
    options?: EventOptions,
  ) {
    return this.track(new LearnMore(properties), options);
  }

  /**
   * load more content
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/load%20more%20content)
   *
   * Triggered when additional content is automatically loaded as the user scrolls near the end of a content list. This event is used to understand how far users progress through extended content lists.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  loadMoreContent(
    properties: LoadMoreContentProperties,
    options?: EventOptions,
  ) {
    return this.track(new LoadMoreContent(properties), options);
  }

  /**
   * log in
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/log%20in)
   *
   * Triggered when a customer completes their "Sign In" on the Welcome screen. Not fired for any automatic log in processes.
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  logIn(
    properties: LogInProperties,
    options?: EventOptions,
  ) {
    return this.track(new LogIn(properties), options);
  }

  /**
   * log out
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/log%20out)
   *
   * Either the customer or the client have initiated the log out process
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  logOut(
    properties?: LogOutProperties,
    options?: EventOptions,
  ) {
    return this.track(new LogOut(properties), options);
  }

  /**
   * navigate to bodi commerce
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/navigate%20to%20bodi%20commerce)
   *
   * Event to track users navigating to the BODi Commerce platform
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  navigateToBodiCommerce(
    properties: NavigateToBodiCommerceProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavigateToBodiCommerce(properties), options);
  }

  /**
   * open chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/open%20chat)
   *
   * Captures when a user opens the chat window.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  openChat(
    properties: OpenChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenChat(properties), options);
  }

  /**
   * play video
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/play%20video)
   *
   * A universal event that is fired when a user initiates video playback.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  playVideo(
    properties: PlayVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlayVideo(properties), options);
  }

  /**
   * play video as anonymous
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/play%20video%20as%20anonymous)
   *
   * This event tracks when an anonymous user (someone who is not logged in) plays a video on our platform. It helps us understand the engagement of anonymous users with our video content.
   *
   *
   * The player will callback to the web app to fire this event.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  playVideoAsAnonymous(
    properties: PlayVideoAsAnonymousProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlayVideoAsAnonymous(properties), options);
  }

  /**
   * play video from block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/play%20video%20from%20block)
   *
   * Fired when the user initiates Video Playback from within a Block.
   *
   * **Notes:**
   *
   * * **screen name** is "block detail"
   *
   * * **screen type** is "block"
   *
   * * This event is not currently supported on the Bike Tablet due to the way the Video Detail screen is architected and being unable to trace where a video was launched from.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  playVideoFromBlock(
    properties: PlayVideoFromBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlayVideoFromBlock(properties), options);
  }

  /**
   * play video from compilation
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/play%20video%20from%20compilation)
   *
   * Fired when the user initiates Video Playback from within a Compilation.
   *
   * **Notes:**
   *
   * * **screen name** is "compilation detail"
   *
   * * **screen type** is "compilation"
   *
   * * This event is not currently supported on the Bike Tablet due to the way the Video Detail screen is architected and being unable to trace where a video was launched from.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  playVideoFromCompilation(
    properties: PlayVideoFromCompilationProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlayVideoFromCompilation(properties), options);
  }

  /**
   * play video from recently watched
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/play%20video%20from%20recently%20watched)
   *
   * This event tracks when a user plays a video from the Jump Back In module.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  playVideoFromRecentlyWatched(
    properties: PlayVideoFromRecentlyWatchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlayVideoFromRecentlyWatched(properties), options);
  }

  /**
   * qualified view as anonymous
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/qualified%20view%20as%20anonymous)
   *
   * Fired when an anonymous user (not logged in) watches past the 25% threshold of a video. The watch percentage threshold is configurable in the remote config for Web.
   *
   * This event is used in our Royalties reporting. It doesn't replace VHS, but it's used as a backup for cases VHS can't track.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  qualifiedViewAsAnonymous(
    properties: QualifiedViewAsAnonymousProperties,
    options?: EventOptions,
  ) {
    return this.track(new QualifiedViewAsAnonymous(properties), options);
  }

  /**
   * refresh access token
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/refresh%20access%20token)
   *
   * Triggered when the token is requested from the client. Approximately every hour.
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  refreshAccessToken(
    properties: RefreshAccessTokenProperties,
    options?: EventOptions,
  ) {
    return this.track(new RefreshAccessToken(properties), options);
  }

  /**
   * remove from favorites
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/remove%20from%20favorites)
   *
   * Tracks when a user removes an item from their Favorites.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  removeFromFavorites(
    properties: RemoveFromFavoritesProperties,
    options?: EventOptions,
  ) {
    return this.track(new RemoveFromFavorites(properties), options);
  }

  /**
   * restart program progress
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/restart%20program%20progress)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  restartProgramProgress(
    properties?: RestartProgramProgressProperties,
    options?: EventOptions,
  ) {
    return this.track(new RestartProgramProgress(properties), options);
  }

  /**
   * restart video
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/restart%20video)
   *
   * **The customer selects "Start Over" when prompted to resume a video**
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  restartVideo(
    properties?: RestartVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new RestartVideo(properties), options);
  }

  /**
   * resume video
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/resume%20video)
   *
   * User selects "Resume" when prompted to resume a video.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  resumeVideo(
    properties?: ResumeVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new ResumeVideo(properties), options);
  }

  /**
   * retake quiz
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/retake%20quiz)
   *
   * Records when a users selects to retake the program quiz.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  retakeQuiz(
    properties?: RetakeQuizProperties,
    options?: EventOptions,
  ) {
    return this.track(new RetakeQuiz(properties), options);
  }

  /**
   * retry log in
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/retry%20log%20in)
   *
   * An automated attempt to log back in after a refresh token error.
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  retryLogIn(
    properties: RetryLogInProperties,
    options?: EventOptions,
  ) {
    return this.track(new RetryLogIn(properties), options);
  }

  /**
   * select 10 minute cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%2010%20minute%20cta)
   *
   * Triggered when a user selects the CTA within the 10 Minute Fitness promotional module on Home to navigate to the 10 Minute Fitness Compilation.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  select10MinuteCta(
    properties?: Select10MinuteCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new Select10MinuteCta(properties), options);
  }

  /**
   * select 5er cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%205er%20cta)
   *
   * User selects the "DO a 5er" CTA which navigates them to the 5er PDP.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  select5ErCta(
    properties?: Select5ErCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new Select5ErCta(properties), options);
  }

  /**
   * select badge
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20badge)
   *
   * Triggered when a customer taps on badge rail item.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectBadge(
    properties: SelectBadgeProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectBadge(properties), options);
  }

  /**
   * select browse all
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20browse%20all)
   *
   * Triggered when a user selects the “Browse all” button on a Landing Page to view the full library.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectBrowseAll(
    properties: SelectBrowseAllProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectBrowseAll(properties), options);
  }

  /**
   * select commerce tile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20commerce%20tile)
   *
   * **User selects (taps, or clicks) a tile in the Commerce Rail.**
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectCommerceTile(
    properties: SelectCommerceTileProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectCommerceTile(properties), options);
  }

  /**
   * select compilation
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20compilation)
   *
   * Fired when the user selects a Compilation.
   *
   * Notes:
   *
   * * Expected `screen name` and `screen type` values: "home", "bodi landing"
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectCompilation(
    properties: SelectCompilationProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectCompilation(properties), options);
  }

  /**
   * select create account
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20create%20account)
   *
   * Tracks when a user initiates the process to set up a new account by selecting the create account option (aka. try for free, get started, etc)
   *
   * This is required for top of funnel analysis so the starting place of all experiments is the same as we change the flow of create account.   For example adding a quiz,  allowing content browse, or displaying before/after success stories still can start at this user intent.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectCreateAccount(
    properties?: SelectCreateAccountProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectCreateAccount(properties), options);
  }

  /**
   * select cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20cta)
   *
   * User selects (taps, or clicks) a CTA.
   *
   * Used for more generic CTAs that appear in editorial modules, as links/urls, and elsewhere across all our products.
   *
   *
   * Featured CTAs can be copied from this, but should follow the same property pattern.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectCta(
    properties: SelectCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectCta(properties), options);
  }

  /**
   * select from favorites
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20from%20favorites)
   *
   * Tracks when a user selects an item from their Favorites.
   *
   * * This event will fire regardless of where the user clicks/taps (Thumbnail or Metadata)
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectFromFavorites(
    properties: SelectFromFavoritesProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectFromFavorites(properties), options);
  }

  /**
   * select link item
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20link%20item)
   *
   * Triggered when a user selects a Link Item from a CoCoA collection, capturing engagement with link-based content tiles.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectLinkItem(
    properties: SelectLinkItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectLinkItem(properties), options);
  }

  /**
   * select locked video
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20locked%20video)
   *
   * A universal event to be fired when a user selects a locked (non-entitled) video.
   *
   * Notes:
   *
   * * If the user selects a locked video within a PDP or the Jump Back In module, then `block slug`, `compliation slug`, or `program slug` should be populated.
   *
   *   * If a video is part of a collection within a Block or Compilation, then `collection slug` should be populated.
   *
   *   * If a video is part of a collection within a legacy PDP, then `collection slug` should be populated with the "section slug" value (if available).
   *
   * * If the user selects a locked video outside of the bounds of a single PDP or Program (such as within Search), then the `block slug`, `compliation slug`, or `program slug`  properties should not be populated.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectLockedVideo(
    properties: SelectLockedVideoProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectLockedVideo(properties), options);
  }

  /**
   * select navigation item
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20navigation%20item)
   *
   * Triggered when a user clicks on an item in the navigation of BOD Web.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectNavigationItem(
    properties: SelectNavigationItemProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectNavigationItem(properties), options);
  }

  /**
   * select program
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20program)
   *
   * Fired when the user selects a Program.
   *
   * Notes:
   *
   * * Expected `screen name` values: "home", "programs", "search"
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectProgram(
    properties: SelectProgramProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectProgram(properties), options);
  }

  /**
   * select progress surface
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20progress%20surface)
   *
   * A user has tapped or clicked on the surface within the My Progress module. Currently, this takes them to the Badges Home, but other destinations and functionality may be expected.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectProgressSurface(
    properties: SelectProgressSurfaceProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectProgressSurface(properties), options);
  }

  /**
   * select quicklink
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20quicklink)
   *
   * User taps on a link in the Quick Links Module on Home.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectQuicklink(
    properties: SelectQuicklinkProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectQuicklink(properties), options);
  }

  /**
   * select quiz result
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20quiz%20result)
   *
   * Records the selection of result from the program quiz.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectQuizResult(
    properties: SelectQuizResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectQuizResult(properties), options);
  }

  /**
   * select recently watched
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20recently%20watched)
   *
   * This event tracks when a user selects the "Recently Watched" call-to-action button to visit a Program or Block Detail Page.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectRecentlyWatched(
    properties?: SelectRecentlyWatchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectRecentlyWatched(properties), options);
  }

  /**
   * select shared profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/select%20shared%20profile)
   *
   * Tracks when a user chooses a shared profile on the account to workout as on their device
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  selectSharedProfile(
    properties?: SelectSharedProfileProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectSharedProfile(properties), options);
  }

  /**
   * share block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/share%20block)
   *
   * Fired when the user selects a Share Option from the Share Dialog, for a Block
   *
   * **Notes:**
   *
   * * **screen name** is "block detail"
   *
   * * **screen type** is "block"
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  shareBlock(
    properties: ShareBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShareBlock(properties), options);
  }

  /**
   * share content
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/share%20content)
   *
   * Fired when the user selects a Share Option from the Share Dialog, for a Program, Block or Compilation (Content Details Page - CDP)
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  shareContent(
    properties?: ShareContentProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShareContent(properties), options);
  }

  /**
   * show alert
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/show%20alert)
   *
   * A generic alert event that is triggered when we show an alert to the user. Segment by `title` to find specific alerts, and additional information in `message`
   *
   *
   * This event is useful for tracking errors that users encounter that we are not able to easily reproduce, and gather intelligence. For example: How many people actually attempt to launch our app in unsupported regions? Which regions?
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  showAlert(
    properties: ShowAlertProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShowAlert(properties), options);
  }

  /**
   * show digital content alert
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/show%20digital%20content%20alert)
   *
   * A user has attempted to play content that they are not entitled to. This is typically content that is not in the Member Library. For example: VIP programs, 4WGP, etc.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  showDigitalContentAlert(
    properties: ShowDigitalContentAlertProperties,
    options?: EventOptions,
  ) {
    return this.track(new ShowDigitalContentAlert(properties), options);
  }

  /**
   * sign up to bodi
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/sign%20up%20to%20bodi)
   *
   * This event is fired every time a customer clicks on one of the "SIGN UP" CTAs on the on BODi LO Landing Page, BODi Interstitial Page, and other sell pages.
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  signUpToBodi(
    properties: SignUpToBodiProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignUpToBodi(properties), options);
  }

  /**
   * start conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/start%20conversation)
   *
   * Captures when a user has started a chat conversation.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  startConversation(
    properties: StartConversationProperties,
    options?: EventOptions,
  ) {
    return this.track(new StartConversation(properties), options);
  }

  /**
   * start feed fm music
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/start%20feed%20fm%20music)
   *
   * This event is triggered when a user starts playing music from the feed.fm service within our platforms.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  startFeedFmMusic(
    properties: StartFeedFmMusicProperties,
    options?: EventOptions,
  ) {
    return this.track(new StartFeedFmMusic(properties), options);
  }

  /**
   * submit activation failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/submit%20activation%20failed)
   *
   * This event is fired when a user failed to activate a code on https://www.beachbodyondemand.com/activate. API version property will be filled in based on using the v1 or v2 API. The V1 API is setup to 5 digit code and the V2 API is setup to use 6 digits code.
   *
   * @param properties The event's properties (e.g. api version)
   * @param options Amplitude event options.
   */
  submitActivationFailed(
    properties: SubmitActivationFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubmitActivationFailed(properties), options);
  }

  /**
   * submit activation success
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/submit%20activation%20success)
   *
   * This event is fired when a user successfully activates a code on https://www.beachbodyondemand.com/activate. API version property will be filled in based on using the v1 or v2 API. The V1 API is setup to 5 digit code and the V2 API is setup to use 6 digits code.
   *
   * @param properties The event's properties (e.g. api version)
   * @param options Amplitude event options.
   */
  submitActivationSuccess(
    properties: SubmitActivationSuccessProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubmitActivationSuccess(properties), options);
  }

  /**
   * switch recently watched tile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/switch%20recently%20watched%20tile)
   *
   * This event is fired when a user switches to a different Program/Block within the Jump Back In module.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  switchRecentlyWatchedTile(
    properties: SwitchRecentlyWatchedTileProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwitchRecentlyWatchedTile(properties), options);
  }

  /**
   * sync web app version
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/sync%20web%20app%20version)
   *
   * This event is fired when the web window is reloaded after comparing client-cached version with the server version, with the server always having the newest version. This can be done with the server, as ideally, the server will immediately be operating on the newest version of the app. Once we identify that the versions differ, we do a reload of the page with window.location.reload() which will ideally reload the app and fetch fresh content from the CDN.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  syncWebAppVersion(
    properties: SyncWebAppVersionProperties,
    options?: EventOptions,
  ) {
    return this.track(new SyncWebAppVersion(properties), options);
  }

  /**
   * take quiz
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/take%20quiz)
   *
   * **Records when a user chooses to start a quiz, capturing the initiation of the quiz-taking process.**
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  takeQuiz(
    properties?: TakeQuizProperties,
    options?: EventOptions,
  ) {
    return this.track(new TakeQuiz(properties), options);
  }

  /**
   * unenroll from program
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/unenroll%20from%20program)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  unenrollFromProgram(
    properties?: UnenrollFromProgramProperties,
    options?: EventOptions,
  ) {
    return this.track(new UnenrollFromProgram(properties), options);
  }

  /**
   * unenroll in track
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/unenroll%20in%20track)
   *
   * User unenrolls in a track for the content
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  unenrollInTrack(
    properties: UnenrollInTrackProperties,
    options?: EventOptions,
  ) {
    return this.track(new UnenrollInTrack(properties), options);
  }

  /**
   * unregister block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/unregister%20block)
   *
   * Fired when the user clicks on the **Joined Now** button on a Block Detail View (which reflects the user's intention to unregister from the Block).
   *
   * **Notes:**
   *
   * * **screen name** is "block detail"
   *
   * * **screen type** is "block"
   *
   * * **block join status** should be "not joined" to reflect the user's intention to be unregistered from the Block.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  unregisterBlock(
    properties: UnregisterBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new UnregisterBlock(properties), options);
  }

  /**
   * view 5er promo
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%205er%20promo)
   *
   * A user views the 5er Promo, at the conclusion of doing a workout.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  view5ErPromo(
    properties?: View5ErPromoProperties,
    options?: EventOptions,
  ) {
    return this.track(new View5ErPromo(properties), options);
  }

  /**
   * view account
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20account)
   *
   * A customer arrives on their Account screen.
   *
   * * Mobile: By tapping on their avatar
   *
   * * Web: By going to "My Dashboard"
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewAccount(
    properties?: ViewAccountProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewAccount(properties), options);
  }

  /**
   * view all classes
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20all%20classes)
   *
   * A customer arrives on the All Classes screen - e.g, by tapping on the "Browse all" button on the BODi landing page,  on the "Browse by category" rail.
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewAllClasses(
    properties?: ViewAllClassesProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewAllClasses(properties), options);
  }

  /**
   * view all favorites
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20all%20favorites)
   *
   * Tracks when a user views the Favorites screen.
   *
   * * Should only be fired once when the user arrives on the Favorites screen, and not fire again when the user switches between tabs.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewAllFavorites(
    properties?: ViewAllFavoritesProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewAllFavorites(properties), options);
  }

  /**
   * view all fitness programs
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20all%20fitness%20programs)
   *
   * Tracks a when user selects the "Browse all" button within the Fitness Hub to view all of our Fitness Programs.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewAllFitnessPrograms(
    properties?: ViewAllFitnessProgramsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewAllFitnessPrograms(properties), options);
  }

  /**
   * view badge celebration
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20badge%20celebration)
   *
   * A user views the Badge Celebration UI, after earning a new badge(s).
   *
   * To check whether the user has seen the Multiple badge Celebration modal, check to see if there are two or more  `badge slugs` added.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBadgeCelebration(
    properties: ViewBadgeCelebrationProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBadgeCelebration(properties), options);
  }

  /**
   * view badge detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20badge%20detail)
   *
   * A customer interacts with a badge - e.g, tapping on the badge in the Badges screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBadgeDetail(
    properties: ViewBadgeDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBadgeDetail(properties), options);
  }

  /**
   * view badge grid
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20badge%20grid)
   *
   * Triggered when a customer lands on the Badge Grid page, or expands the display to see more (e.g, clicks "Load More" on the bike). Normally expected after they have visited Badge Home, and wanted to dive deeper.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBadgeGrid(
    properties?: ViewBadgeGridProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBadgeGrid(properties), options);
  }

  /**
   * view badges
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20badges)
   *
   * A customer arrives on the Badges screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBadges(
    properties?: ViewBadgesProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBadges(properties), options);
  }

  /**
   * view block detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20block%20detail)
   *
   * Fired when the user first lands on a Block Detail View.
   *
   * **Notes:**
   *
   * * **screen type** is "block"
   *
   * * Another event should **not** be fired when the user switches sections (tabs) within the same Block Detail View.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBlockDetail(
    properties: ViewBlockDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBlockDetail(properties), options);
  }

  /**
   * view bodi interstitial page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20bodi%20interstitial%20page)
   *
   * Fired when the user views the BODi Interstitial Page.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewBodiInterstitialPage(
    properties: ViewBodiInterstitialPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewBodiInterstitialPage(properties), options);
  }

  /**
   * view class detail within block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20class%20detail%20within%20block)
   *
   * Fired when the user opens a Live Class Detail screen from within a Block Detail View.
   *
   * * This event is not applicable on our TV Apps, as we don't have individual Live Class Detail screens.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewClassDetailWithinBlock(
    properties: ViewClassDetailWithinBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewClassDetailWithinBlock(properties), options);
  }

  /**
   * view class schedule
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20class%20schedule)
   *
   * A customer arrives on the Class Schedule - e.g, tapping on the "Full Schedule" button on the Classes (Formally BODi) landing page
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewClassSchedule(
    properties?: ViewClassScheduleProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewClassSchedule(properties), options);
  }

  /**
   * view classes
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20classes)
   *
   * A customer arrives on the workouts screen in Fitness Hub.
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewClasses(
    properties?: ViewClassesProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewClasses(properties), options);
  }

  /**
   * view compilation detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20compilation%20detail)
   *
   * Fired when the user first lands on a Compilation Detail View.
   *
   * **Notes:**
   *
   * * **screen type** is "compilation"
   *
   * * Another event should **not** be fired when the user switches sections (tabs) within the same Compilation Detail View.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewCompilationDetail(
    properties: ViewCompilationDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCompilationDetail(properties), options);
  }

  /**
   * view create account screen
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20create%20account%20screen)
   *
   * Fired when the user views the Create Account screen.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewCreateAccountScreen(
    properties?: ViewCreateAccountScreenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCreateAccountScreen(properties), options);
  }

  /**
   * view device activation
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20device%20activation)
   *
   * Tracks when a user views the Device Activation screen on TV, which displays both an activation code and a QR code shortcut.
   *
   *
   *  Prior to the Auth0 migration, this event tracked viewing the Device Activation Page on BOD.com.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewDeviceActivation(
    properties?: ViewDeviceActivationProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewDeviceActivation(properties), options);
  }

  /**
   * view error screen
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20error%20screen)
   *
   * Indicates a failure to load the requested screen, capturing error details for troubleshooting and monitoring app stability.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewErrorScreen(
    properties: ViewErrorScreenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewErrorScreen(properties), options);
  }

  /**
   * view fitness quiz
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20fitness%20quiz)
   *
   * This event tracks when a user views the fitness quiz on BOD.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewFitnessQuiz(
    properties: ViewFitnessQuizProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewFitnessQuiz(properties), options);
  }

  /**
   * view forgot password
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20forgot%20password)
   *
   * Triggered when a user has tapped on "Forgot Password" and sees the email submission screen.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewForgotPassword(
    properties?: ViewForgotPasswordProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewForgotPassword(properties), options);
  }

  /**
   * view free account registration page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20free%20account%20registration%20page)
   *
   * Fired when a user views the Free Account Registration page on Web.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewFreeAccountRegistrationPage(
    properties?: ViewFreeAccountRegistrationPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewFreeAccountRegistrationPage(properties), options);
  }

  /**
   * view group detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20group%20detail)
   *
   * A customer interacts with a BODgroup - e.g, by tapping on a BODgroup in the Groups screen.
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewGroupDetail(
    properties: ViewGroupDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewGroupDetail(properties), options);
  }

  /**
   * view groups
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20groups)
   *
   * A customer navigates to the BODgroups screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewGroups(
    properties: ViewGroupsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewGroups(properties), options);
  }

  /**
   * view home
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20home)
   *
   * A customer navigates to the Home screen
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewHome(
    properties?: ViewHomeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewHome(properties), options);
  }

  /**
   * view login
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20login)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewLogin(
    properties?: ViewLoginProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewLogin(properties), options);
  }

  /**
   * view my settings
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20my%20settings)
   *
   * A customer navigates to the My Settings screen in the Account screen.
   *
   * * On Web this is a Modal
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewMySettings(
    properties?: ViewMySettingsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewMySettings(properties), options);
  }

  /**
   * view post workout screen
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20post%20workout%20screen)
   *
   * Triggered when the Post-Workout Screen (or modal) is displayed to the user immediately after completing a workout. This event captures the entry point into the Post-Workout Experience.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewPostWorkoutScreen(
    properties: ViewPostWorkoutScreenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewPostWorkoutScreen(properties), options);
  }

  /**
   * view profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20profile)
   *
   * A customer interacts with a profile - e.g, tapping on their own profile in the Account screen, or interacting with another participant's profile
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewProfile(
    properties: ViewProfileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewProfile(properties), options);
  }

  /**
   * view program detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20program%20detail)
   *
   * A customer interacts with a Program - e.g, tapping on a tile in the Programs screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewProgramDetail(
    properties?: ViewProgramDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewProgramDetail(properties), options);
  }

  /**
   * view program results
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20program%20results)
   *
   * Tracks when a user views the Program Results screen in Fitness Hub.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewProgramResults(
    properties?: ViewProgramResultsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewProgramResults(properties), options);
  }

  /**
   * view programs
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20programs)
   *
   * A customer navigates to the Programs screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewPrograms(
    properties?: ViewProgramsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewPrograms(properties), options);
  }

  /**
   * view programs landing
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20programs%20landing)
   *
   * Tracks when a user views the Programs Landing screen in Fitness Hub.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewProgramsLanding(
    properties?: ViewProgramsLandingProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewProgramsLanding(properties), options);
  }

  /**
   * view quiz question
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20quiz%20question)
   *
   * Tracks when a user is presented with a quiz question, capturing the type of the question.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewQuizQuestion(
    properties: ViewQuizQuestionProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewQuizQuestion(properties), options);
  }

  /**
   * view quiz results
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20quiz%20results)
   *
   * Records when a user views the results for the quiz after completing the quiz.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewQuizResults(
    properties?: ViewQuizResultsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewQuizResults(properties), options);
  }

  /**
   * view search
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20search)
   *
   * A customer navigates to the Search screen. Mainly this happens on the TV platforms.
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewSearch(
    properties?: ViewSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewSearch(properties), options);
  }

  /**
   * view tracking
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20tracking)
   *
   * A customer navigates to the Tracking screen
   *
   * Owner: cmcgrouther@beachbody.com
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewTracking(
    properties: ViewTrackingProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewTracking(properties), options);
  }

  /**
   * view value prop modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20value%20prop%20modal)
   *
   * This event fires when an anon user sees the Value Prop Modal, shown after watching a video.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewValuePropModal(
    properties?: ViewValuePropModalProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewValuePropModal(properties), options);
  }

  /**
   * view video detail within block
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20video%20detail%20within%20block)
   *
   * Fired when the user opens a Video Detail screen from within a Block Detail View.
   *
   * * This event is not applicable on our TV Apps, as we don't have individual Video Detail screens.
   *
   * Owner: Hunter Owens
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewVideoDetailWithinBlock(
    properties: ViewVideoDetailWithinBlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewVideoDetailWithinBlock(properties), options);
  }

  /**
   * view video details
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20video%20details)
   *
   * Event when the video details screen is presented
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewVideoDetails(
    properties: ViewVideoDetailsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewVideoDetails(properties), options);
  }

  /**
   * view welcome
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20welcome)
   *
   * A customer navigates to the Welcome screen. Normally done after a Log out event or a fresh install.
   *
   * Owner: Clark McNally
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewWelcome(
    properties?: ViewWelcomeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewWelcome(properties), options);
  }

  /**
   * view workout results
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20workout%20results)
   *
   * Tracks when a user views the Workout Results screen in Fitness Hub.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewWorkoutResults(
    properties?: ViewWorkoutResultsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewWorkoutResults(properties), options);
  }

  /**
   * view workouts landing
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/BOD%20Direct%20Prod/events/main/latest/view%20workouts%20landing)
   *
   * Tracks when a user views the Workouts Landing screen in Fitness Hub.
   *
   * @param properties The event's properties (e.g. app name)
   * @param options Amplitude event options.
   */
  viewWorkoutsLanding(
    properties?: ViewWorkoutsLandingProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewWorkoutsLanding(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
